import loadable from "@loadable/component"
import LoadingSpinner from "./components/spinner/LoadingSpinner"
import { resetClientCredentials, setClientCredentials } from "./redux-store/LoginAuthSlice"
import { ROUTES } from "./config/routes"
import { verifyUserId } from "./utilities"
import { Route, Routes } from "react-router-dom"

const options = {
  fallback: <LoadingSpinner />
}

export const onboardingOrWholeCipEnum = ['onboarding', 'CIP', "only_taas"]
export const onboardingStateEnum = ['onboarding_with_forms', 'onboarding_without_forms', 'onboarding_with_nda', 'onboarding_with_sla', "none"]
export const cipVersionEnum = ["Quantitative Data Collection", "Quantitative + Qualitative + Desk Research"]

const PublicRoutes = loadable(() => import(/* webpackChunkName: "PublicRoutes" */ "./routes-segregation/public/PublicRoutes"), options)
const OurCapabilitiesLazyV2 = loadable(() => import(/* webpackChunkName: "OurCapabilitiesLazyV2" */ "./routes-segregation/v2/our-capabilities/OurCapabilitiesLazyV2"), options)
const TaaSLazy = loadable(() => import(/* webpackChunkName: "TaasLazy" */ "./routes-segregation/taas/TaasLazy"), options)
const ClientRoutesLazy = loadable(() => import(/* webpackChunkName: "ClientRoutesLazy" */ "./routes-segregation/client/ClientRoutesLazy"), options)
const OnboardingLazy = loadable(() => import(/* webpackChunkName: "OnboardingLazy" */ "./routes-segregation/onboarding/OnboardingLazy"), options)
const OurCapabilities = loadable(() => import(/* webpackChunkName: "OurCapabilities" */ "./pages/our-services/OurServices"), options)
const OurCapabilitiesParent = loadable(() => import(/* webpackChunkName: "OurCapabilitiesParent" */ "./pages/our-capabilites/OurCapabilitiesParent"), options)


export const taaSRelatedUseEffect = async (currentPath, dispatch, navigate, verifyUser, location) => {
  const clientIndex = new URLSearchParams(location.search).get("clientIndex")

  let urlSplit = currentPath.split("/")

  if (currentPath.startsWith(ROUTES.TAAS.TAAS_ROOT)) {
    await verifyUserId(urlSplit[2], dispatch, navigate, verifyUser, setClientCredentials, clientIndex)
    navigate(`${ROUTES.TAAS.TAAS_ROOT}/${urlSplit[2]}/${ROUTES.TAAS.TAAS_COST_ESTIMATE}`)
    return;
  }
  if (currentPath.startsWith(ROUTES.UNIQUE_KEY_FOR_TAAS_ONLY)) {
    const { cipAccessControl } = await verifyUserId(urlSplit[3], dispatch, navigate, verifyUser, setClientCredentials, clientIndex)
    if (cipAccessControl?.accessRight === onboardingOrWholeCipEnum[2]) {
      navigate(`${ROUTES.UNIQUE_KEY_FOR_TAAS_ONLY}/${urlSplit[3]}/${ROUTES.OUR_CAPABILITIES.TAAS}`)
    }
    else {
      dispatch(resetClientCredentials())
      navigate(ROUTES.LOGIN)
    }
    return;
  }
  if (currentPath.startsWith(`${ROUTES.CIP_V2.ROOT}/${ROUTES.CIP_V2.TAAS.ROOT}`)) {
    const { cipVersion } = await verifyUserId(urlSplit[3], dispatch, navigate, verifyUser, setClientCredentials, clientIndex)
    if (cipVersion === cipVersionEnum[1]) {
      navigate(`${ROUTES.CIP_V2.ROOT}/${ROUTES.CIP_V2.TAAS.ROOT}/${urlSplit[3]}`)
    }
    else {
      dispatch(resetClientCredentials())
      navigate(ROUTES.LOGIN)
    }
    return;
  }
}

export const onboardingRelatedUseEffect = async (currentPath, dispatch, navigate, verifyUser, location) => {
  const clientIndex = new URLSearchParams(location.search).get("clientIndex")
  let urlSplit = currentPath.split("/")

  if (currentPath.includes(`${ROUTES.ONBOARDING_CLIENT.ONBOARDING_WITHOUT_FORMS}`)) {
    const { cipAccessControl } = await verifyUserId(urlSplit[3], dispatch, navigate, verifyUser, setClientCredentials, clientIndex)
    if ((cipAccessControl?.onboardingState === onboardingStateEnum[1])) {
    //   navigate(`${ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP}/${ROUTES.ONBOARDING_CLIENT.ONBOARDING_WITHOUT_FORMS}/${urlSplit[3]}/${ROUTES.ONBOARDING_CLIENT.ONBOARDING_CLIENT_INFO}`)
    }
    else {
      dispatch(resetClientCredentials())
      navigate(ROUTES.LOGIN)
    }
  }

  else if (currentPath.startsWith(`${ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP}`)) {
    const { cipAccessControl } = await verifyUserId(urlSplit[2], dispatch, navigate, verifyUser, setClientCredentials, clientIndex)
    if ((cipAccessControl?.onboardingState === onboardingStateEnum[0])) {
    //   navigate(`${ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP}/${urlSplit[2]}/${ROUTES.ONBOARDING_CLIENT.CLIENT}`)
    }
    else {
      dispatch(resetClientCredentials())
      navigate(ROUTES.LOGIN)
    }
  }
  return;
}



export const registerAppRoutes = (userDetails) => {
  const { cipVersion, cipAccessControl } = userDetails
  return (
    <>
      {cipAccessControl?.accessRight === onboardingOrWholeCipEnum[2] &&
        <Routes>
          <Route path={`${ROUTES.UNIQUE_KEY_FOR_TAAS_ONLY}/${ROUTES.OUR_CAPABILITIES.OUR_CAPABILITIES_USER_KEY}/${ROUTES.OUR_CAPABILITIES.TAAS}`} element={<OurCapabilities taasOnly={true} />} />
          <Route path={`${ROUTES.UNIQUE_KEY_FOR_TAAS_ONLY}/${ROUTES.OUR_CAPABILITIES.OUR_CAPABILITIES_USER_KEY}/${ROUTES.OUR_CAPABILITIES.TAAS}/${ROUTES.OUR_CAPABILITIES.SLUG}`} element={<OurCapabilitiesParent taasOnly={true} />} />
        </Routes>
      }
      <PublicRoutes cipVersion={cipVersion} />
      <OnboardingLazy cipAccessControl={cipAccessControl} />
      {cipAccessControl?.accessRight === onboardingOrWholeCipEnum[1] && <ClientRoutesLazy userDetails={userDetails} />}
      <OurCapabilitiesLazyV2 cipAccessControl={cipAccessControl} />
      {(cipAccessControl?.accessRight === onboardingOrWholeCipEnum[2] || cipAccessControl?.accessRight === onboardingOrWholeCipEnum[1]) && <TaaSLazy userDetails={userDetails} />}
    </>
  )
}
